import { Component, Input, OnInit, ViewEncapsulation, Injector } from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import { Module, TextPosition } from '../../model/ModuleModel';
import { EmtpyStateService } from 'projects/common/services/empty-state.service';

type GridContainerOptions = {
    full_width?: boolean;
};

type GridContainerData = {
    modules: Module[];
    options?: GridContainerOptions;
};

@Component({
    selector: 'grid-container',
    template: `
        <text-layout
            [textPosition]="textPosition"
            [screenType]="screenType"
            [module]="module"
        >
            <div class="grid-container" 
                [style.--cols]="cols"
                [class.-full-width]="isFullWidth"
                [class.-limited]="!isFullWidth"
                >
                <meta-component
                    *ngFor="let child of module.data.modules"
                    [module]="child"
                    [currency]="currency"
                    [device]="device"
                    [flow]="flow"
                    [product]="product"
                    [containerId]="getContainerId()">
                </meta-component>
            </div>
        </text-layout>
    `,
    styleUrls: ['./grid-container.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GridContainerComponent extends AbstractComponent implements OnInit {
    private static MODULE_ID = 'GridContainerModule';

    @Input() override module: Module<GridContainerData>;
    @Input() currency: any;
    @Input() device: any;
    @Input() override flow: string;

    textPosition: TextPosition;
    cols: number;

    constructor(injector: Injector, private emptyStateService: EmtpyStateService) {
        super(injector);
    }

    getModuleId(): string {
        return GridContainerComponent.MODULE_ID;
    }

    ngOnInit(): void {
        this.module.data ??= { modules: [] };
        this.module.data.modules ??= [];
        this.module.data.modules.forEach((m) => (m.row_number = this.module.row_number));
        this.emptyStateService.analyzeEmptyStates(this.module.data.modules, this.getContainerId());

        this.textPosition = this.module.text_position ?? TextPosition.TOP;
        
        const moduleCols = this.module?.data?.modules?.length ?? 1;
        this.cols = Math.max(1, moduleCols);
    }

    getContainerId(): string {
        return this.module.unique_id || this.getModuleId();
    }

    get isFullWidth(): boolean {
        return this.module?.data?.options?.full_width ?? true;
    }
}
